import { HOST } from "common-import/constants";
import { observable, autorun, computed } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from './CartOrder.API';

class CartOrderStore {

  @observable list_WAITING = [];

  @observable list_COMPLETED = [];

  @observable list_SHIPPED_ORDERS = [];

  @observable list_ORDER_IN_PROCESS = [];

  @observable list_FAIL_TO_CHARGE = [];

  @observable list_CANCELED_ORDERS = [];

  @observable currentOrder = {};

  @computed get allListOrder() {
    return [
      ...this.list_WAITING,
      ...this.list_COMPLETED,
      ...this.list_SHIPPED_ORDERS,
      ...this.list_ORDER_IN_PROCESS,
      ...this.list_FAIL_TO_CHARGE,
      ...this.list_CANCELED_ORDERS,
    ];
  }

  setProp = (prop, value) => { this[prop] = value  }

  setCurrentOrder = id => {
    let current = this.allListOrder.find(val => val.id == id);
    if(current == undefined) return {};
    this.currentOrder = current;
    return current;
  }

  getListStatus = async (status, page) => {
    let res = await api.adminList({
      "status": status,
      "orderBy":"createdAt",
      "orderType":"DESC",
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this["list_"+status] = json.data;
    return { status: true };
  }
  
  getListNotApproved = async (page) => {
    let res = await api.adminList({
      "status":"WAITING",
      "orderBy":"createdAt",
      "orderType":"DESC",
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  }

  getListApproved = async (page) => {
    let res = await api.adminList({
      "status":"COMPLETED",
      "orderBy":"createdAt",
      "orderType":"DESC",
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  }

  deleteOrder = async (id) => {
    const res = await api.deleteOrder(id);
    const json = await res.json();
    return json;
  }

  approve = async ({id, status}) => {
    let res = await api.changeStatus({
      "id": id,
      "status": status
    });
    let json = await res.json();
    // if(!json.error) 
    return json;
  }
}

export default new CartOrderStore();


// WEBPACK FOOTER //
// ./src/services/cartOrder/CartOrder.Store.js